module.exports = __webpack_public_path__ + "img/Machine8.7231504b.svg";